import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { FC, useState } from "react";
import CstmBtn from "Components/CstmBtn";
import { ThresholdsModalProps } from "DataTypes/PatientManagement.type";
import PatientThreshold from "Components/PatientThreshold";

const ThresholdsModal: FC<ThresholdsModalProps> = ({ setClose }) => {
  const { patientId } = useParams();
  const { selectedPrgm }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const [counterSave, setCounterSave] = useState(0);

  return (
    <Box height="96%">
      <Box height="96%">
        <PatientThreshold
          showSaveButton={false}
          isSavedCounter={counterSave}
          patientId={patientId}
        />
      </Box>
      <Box
        sx={{
          "&>button": { ml: 1, width: "10%" },
          display: "flex",
          justifyContent: "flex-end",
          mt: 1,
        }}
      >
        {selectedPrgm.teamMember && (
          <CstmBtn
            label="Save"
            onClick={() => setCounterSave(counterSave + 1)}
          />
        )}
        <CstmBtn label="Close" onClick={setClose} btnType="border" />
      </Box>
    </Box>
  );
};

export default ThresholdsModal;
